import { Link } from 'react-router-dom';
import logoImg from '../assets/logo.png';

export default function ImprintPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100">
      <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center gap-3">
          <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <img src={logoImg} alt="Logo" className="w-8 h-8" />
            <span className="font-semibold text-lg">Unified LLM Platform</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-2">Imprint</h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-10">Legal disclosure pursuant to § 5 TMG</p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Service Provider</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            Imran Hussain<br />
            IH Software Services Provider<br />
            Goldäckerstraße 66<br />
            71144 Steinenbronn<br />
            Germany
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Contact</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            Phone: +49 176 37130790<br />
            Email: <a href="mailto:info@imranhussain.de" className="text-blue-600 dark:text-blue-400 hover:underline">info@imranhussain.de</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">VAT Identification Number</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            VAT ID pursuant to § 27a of the German VAT Act: DE362930028
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Professional Information</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            Professional title: IT Services / Software Development &amp; AI Solutions<br />
            Competent chamber: IHK Stuttgart<br />
            Country of award: Germany
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Liability for Content</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            As a service provider we are responsible for our own content on this platform in accordance with general law
            pursuant to § 7 para. 1 TMG. According to §§ 8 to 10 TMG, however, we are not obligated as a service
            provider to monitor transmitted or stored third-party information or to investigate circumstances that
            indicate illegal activity. Obligations to remove or block the use of information in accordance with general
            law remain unaffected. Liability in this regard is only possible from the point in time at which knowledge
            of a specific infringement becomes known. Upon becoming aware of corresponding infringements, we will
            remove this content immediately.
          </p>
          <p className="mt-3 text-gray-700 dark:text-gray-300 leading-relaxed">
            AI-generated content on this platform is produced by third-party language model providers (OpenAI,
            Anthropic, Google, Mistral, DeepSeek, and others). The platform operator does not guarantee the
            accuracy, completeness, or fitness for purpose of any AI-generated output.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Liability for Links</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            Our platform may contain links to external third-party websites over whose content we have no control.
            We therefore accept no liability for this external content. The respective provider or operator of the
            linked pages is always responsible for the content of those pages. The linked pages were checked for
            possible legal violations at the time of linking. No illegal content was apparent at the time of linking.
            Permanent monitoring of the content of linked pages is not reasonable without concrete evidence of an
            infringement. Upon becoming aware of legal violations, we will remove such links immediately.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Copyright</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            The content and works created by the site operators on this platform are subject to German copyright law.
            Reproduction, processing, distribution and any kind of exploitation outside the limits of copyright law
            require the written consent of the respective author or creator. Downloads and copies of this platform
            are only permitted for private, non-commercial use. Insofar as the content on this platform was not
            created by the operator, the copyrights of third parties are respected. Should you nevertheless become
            aware of a copyright infringement, please notify us accordingly. Upon becoming aware of infringements,
            we will remove such content immediately.
          </p>
          <p className="mt-3 text-gray-700 dark:text-gray-300 leading-relaxed">
            AI model outputs, weights, and underlying technologies are the intellectual property of their respective
            providers and are subject to their individual terms of service and licensing agreements.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3">Consumer Dispute Resolution</h2>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            We are not willing or obligated to participate in dispute resolution proceedings before a consumer
            arbitration board.
          </p>
        </section>

        <p className="text-sm text-gray-400 dark:text-gray-500 mt-12">Last updated: March 2026</p>
      </main>

      <footer className="border-t border-gray-200 dark:border-gray-800 py-6 px-6 mt-12">
        <div className="max-w-4xl mx-auto flex flex-wrap gap-4 text-sm text-gray-500 dark:text-gray-400">
          <Link to="/imprint" className="hover:text-gray-900 dark:hover:text-white transition-colors">Imprint</Link>
          <Link to="/privacy" className="hover:text-gray-900 dark:hover:text-white transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-gray-900 dark:hover:text-white transition-colors">Terms &amp; Conditions</Link>
          <Link to="/" className="hover:text-gray-900 dark:hover:text-white transition-colors">Back to Home</Link>
        </div>
      </footer>
    </div>
  );
}
